<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>


<div id="attractions" class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container d-none d-md-flex">
    <div class="card unique-card">
      <img src="assets/images/Sula Vineyards.jpg" class="card-img-top" alt="Water Park">
      <div class="card-body">
        <p class="card-text">Sula Vineyards</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Pandav Leni.jpg" class="card-img-top" alt="Pandav Leni">
      <div class="card-body">
        <p class="card-text">Pandav Leni</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Kalaram Temple.jpg" class="card-img-top" alt="Kalaram Temple">
      <div class="card-body">
        <p class="card-text">Kalaram Temple</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Soma Vine Village.jpg" class="card-img-top" alt="Soma Vine Village">
      <div class="card-body">
        <p class="card-text">Soma Vine Village</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Gangapur Dam.jpg" class="card-img-top" alt="Gangapur Dam">
      <div class="card-body">
        <p class="card-text">Gangapur Dam</p>
      </div>
    </div>
  </div>
</div>




<div class="unique-carousel-wrapper d-block d-md-none">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-carousel-card shadow-lg border-0 rounded overflow-hidden">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner unique-carousel-inner">
        <!-- Loop through the items using Angular's *ngFor -->
        <div
          *ngFor="let item of carouselItems; let i = index"
          class="carousel-item"
          [ngClass]="{ 'active': i === 0 }"
        >
          <div class="unique-carousel-item-content text-center p-3">
            <div class="unique-carousel-item-card">
              <img [src]="item.imgSrc" [alt]="item.title" class="img-fluid circular-image">
              <h2 class="mt-3">{{ item.title }}</h2>
              <p>{{ item.age }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Carousel Controls -->
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>









<div class="container my-5">
  <div class="row" id="testimonials">
    <!-- First Column -->
    <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
      <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
      <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
      <a href="https://search.google.com/local/writereview?placeid=ChIJ-1Czh8jr3TsRnA4ltCGiVn4" class="btn btn-primary btn-lg writereview">
      <div style="padding-left: 10px;padding-right: 10px;">
        Write a Review
      </div>
    </a>
    </div>

    <!-- Second Column (Carousel for Desktop) -->
    <div class="col-md-8 mb-4 d-md-block">
      <div class="carousel-controls">
        <a href="#carouselExampleControlsreview" role="button" data-slide="prev" class="carousel-control-prev">
          <span aria-hidden="true" class="carousel-control-prev-icon"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a href="#carouselExampleControlsreview" role="button" data-slide="next" class="carousel-control-next">
          <span aria-hidden="true" class="carousel-control-next-icon"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControlsreview" data-ride="carousel" class="carousel slide">
          <div class="carousel-inner style_carasol" style="display: block;">
            
            <div data-interval="10000" class="carousel-item active">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Ved Bhandare" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Ashish Ojha</h5>
                    <p class="small text-muted mb-2 review-text">I recently stayed at this hotel, and it was an exceptional experience. The property is well-maintained, very spacious, and impeccably clean. From the moment I arrived, the staff was warm, welcoming, and extremely supportive, ensuring a comfortable stay.
                      The room was spacious, spotless, and well-equipped with all necessary amenities. The overall ambiance of the hotel was relaxing, making it a perfect place to unwind. A special appreciation to the service staff for their kindness and prompt assistance throughout my stay.</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Vaishali Kokane" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Kalpesh Borse</h5>
                    <p class="small text-muted mb-2 review-text">From the moment I arrived, the staff was incredibly welcoming and attentive, ensuring that every detail of my stay was perfect. The room was spacious, immaculately clean, and equipped with all the amenities I could possibly need for a comfortable stay.
                      The location was ideal, offering easy access to local attractions and restaurants. I also appreciated the thoughtful touches, like the complimentary breakfast and the well-maintained facilities.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="DR.SACHIN NARHAR JOSHI" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Pawanesh Pandey</h5>
                    <p class="small text-muted mb-2 review-text">The staff was incredibly welcoming and attentive, ensuring all my needs were met promptly. The rooms were spacious, and equipped with modern amenities, making my stay comfortable and relaxing.
                      The location was perfect, close to key attractions yet peaceful. The on-site dining was excellent, offering a wide variety of delicious options.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="shyam mourya" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Jyoti Nade</h5>
                    <p class="small text-muted mb-2 review-text">Had a pleasant stay here with my family. We got a room with balcony view which was great. The food items were great.
                      The location is good it is just on the highway.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Koustubh Mangrulkar" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Bitu Yadav</h5>
                    <p class="small text-muted mb-2 review-text">staff was incredibly welcoming and attentive, ensuring all my needs were met promptly. The rooms were spacious, and equipped with modern amenities, making my stay comfortable and relaxing. </p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Rohan More</h5>
                    <p class="small text-muted mb-2 review-text">A reviewer noted the hotel's great location, beautiful surroundings, and friendly, helpful staff. They also said the rooms were well-equipped and comfortable, and the food was good value for money.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Shiwang Tiwari</h5>
                    <p class="small text-muted mb-2 review-text">It is in a very good place and the atmosphere here is very good due to which every person will not have the problem of pollution and their food will be good.This place is good for everything and every food item is available here which is very good for us and we don't have to go to any other shop so this is even better</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Sandip Gholap</h5>
                    <p class="small text-muted mb-2 review-text">Prompt service and polite staff.
                      Dining experience was fantastic.
                      I really enjoyed hospitality at this place.
                      Worth visit once.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">darpan patole</h5>
                    <p class="small text-muted mb-2 review-text">Awesome property ✌️ it was good staying with them 💯 very nice & clean room , staff was also very helpful... overall very nice experience...must suggested property ✅</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Ruchita Bhure</h5>
                    <p class="small text-muted mb-2 review-text">This hotel is very good bcz of their rooms, staff, service and main thing is food is awesome.Plz go ahead</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Ajeet Gupta</h5>
                    <p class="small text-muted mb-2 review-text">"Very caring, helpful-room very clean-breakfast wonderful, thankyou " ...
                      Very nice location and very comfortable bed, very good worker.
                      What a tasty food.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Rajkumar Yadav</h5>
                    <p class="small text-muted mb-2 review-text">Staff is very polite and the room quality and condition was neat and clean food is also very tasty really enjoyed.</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Tarasankar das (Guddu)</h5>
                    <p class="small text-muted mb-2 review-text">I recently had the pleasure of staying at Swiss Trafalgar Luxury Hotels, and it was truly an unforgettable experience from start to finish. From the moment I arrived, the level of service and attention to detail was nothing short of exceptional.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Amit Singh</h5>
                    <p class="small text-muted mb-2 review-text">The best place in huge lobby
                      Rooms are very spacious
                      All rooms pool facing
                      Laxmi in front office is very helpfull ashwariya gives heavy food discount
                      Value for money.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Ritesh Marathe</h5>
                    <p class="small text-muted mb-2 review-text">This hotel really luxury like 5 star hotel , they have all amenities like rooms ,pool , bar , healthclub and all staff was very nice , food was very delicious .</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Swapnil More</h5>
                    <p class="small text-muted mb-2 review-text">This Hotel provides comfortable and affordable accommodations with essential amenities like clean rooms, Wi-Fi, and decent service. It’s a practical choice for families and friends. Best Service ever</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Prince Vaishnav</h5>
                    <p class="small text-muted mb-2 review-text">Very good services and room's cleaning is absolutely delightful.This is the place where u can enjoy your mood</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">sriparna mukherjee</h5>
                    <p class="small text-muted mb-2 review-text">Visited for business purpose. Well management by Mr Meena(GM). Very decent person resolving problems very fast.
                      Rooms are good. But othority should be provide geyser in bathroom.</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">NARESH KUMAR</h5>
                    <p class="small text-muted mb-2 review-text">Real taste of food I enjoyed here and the room is best with helpful staff and the receptionist was so polite.</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Jafar Patel</h5>
                    <p class="small text-muted mb-2 review-text">Had a great time at swiss traffalgaar rooms were spacious
                      Staff was culteow & helpful they upgraded our room
                      Overall feel of the hotel was fantastic</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
    




  </div>
</div>






  <div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120006.1994982123!2d73.67918790414019!3d19.958353189043713!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bddebc887b350fb%3A0x7e56a221b4250e9c!2s910%2C%20Mumbai%20-%20Agra%20Rd%2C%20Dnyaneshwar%20Nagar%2C%20Pathardi%20Phata%2C%20Nashik%2C%20Maharashtra%20422009!3m2!1d19.9583722!2d73.7615896!5e0!3m2!1sen!2sin!4v1729820586391!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div   class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
        <h3>Make Unforgettable Memories</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i> {{property?.mobile}}
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i> {{property?.email}}
        </p>

      </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE" storage-option="none" language-code="en" max-query-length="-1"   >
  <df-messenger-chat-bubble  id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank" >
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>

